export const DynamicCloseIcon = ({ size = 18 }) => {
  const strokeWidth = size / 12;
  const padding = strokeWidth * 1.5;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1={padding}
        y1={padding}
        x2={size - padding}
        y2={size - padding}
        stroke="#8774FF"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        x1={size - padding}
        y1={padding}
        x2={padding}
        y2={size - padding}
        stroke="#8774FF"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};
